import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import { BRAND_NAME } from "@constants"
import { Trans, useTranslation } from "react-i18next";
import "./css/connectedModal.scss";

interface IParams {
    isModalOpen: boolean;
    setModalOpen(isModalOpen: boolean): void;
}

export const ConnectedModal = (props: IParams) => {
    const { isModalOpen, setModalOpen } = props;
    const closeModal = () => setModalOpen(!isModalOpen);
    const { t } = useTranslation("summary");

    return (
        <Dialog fullWidth maxWidth="md" open={isModalOpen} onClose={closeModal}>
            <Grid className="dialog-close" container justify="flex-end">
                <Grid className="dialog-close__icon" item>
                    <IconButton aria-label="close" onClick={closeModal}>
                        <CloseIcon color="disabled" />
                    </IconButton>
                </Grid>
            </Grid>
            <DialogTitle disableTypography>
                <Grid container justify="center">
                    <Grid item sm={12} xs={6}>
                        <Typography align="center" color="secondary" variant="h3">
                            {t("updateInformation")}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Typography align="center" variant="body1">
                    <Trans>{t("updateInformationModal", { brand: BRAND_NAME })}</Trans>
                </Typography>
            </DialogContent>
            <DialogActions>
                <Grid container justify="center">
                    <Grid item md={2} sm={3} xs={6}>
                        <Button color="secondary" fullWidth size="large" variant="contained" onClick={closeModal}>
                            {t("understand")}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};
